// extracted by mini-css-extract-plugin
export var formContainer = "_e6-0";
export var message = "_e6-1";